import { FC } from "react";
import ReactApexChart from "react-apexcharts";
import "./custom.scss";
import { MONTHS } from "lib/constants";
import { getArrayOfValuesFromArray } from "lib/utils/array-utils";

interface RoomOccupancyChartProps {
  roomDetails: RoomOccupancyEntry[];
  width?: string | number;
  height?: string | number;
  className?: string;
  isShowAllMonths?: boolean;
}

const RoomOccupancyChart: FC<RoomOccupancyChartProps> = ({
  roomDetails,
  width,
  height,
  className,
  isShowAllMonths = false
}) => {

  // Extract months and compute occupancy data
  const categories: string[] = isShowAllMonths ? MONTHS : getArrayOfValuesFromArray(roomDetails, "month");

  const occupiedData: number[] = [];
  const availableData: number[] = [];


  if (isShowAllMonths) {
    const totalrooms = roomDetails?.[0]?.totalrooms ?? 0;

    if (roomDetails?.length > 0) {
      MONTHS.forEach((monthName) => {

        const found = roomDetails.find(room => room?.month.toLocaleLowerCase() === monthName.toLocaleLowerCase());

        const occupied = found?.occupied ?? 0;
        const safeTotal = Math.max(occupied, totalrooms);

        if (found) {
          occupiedData.push(occupied);
          availableData.push(safeTotal - occupied);
        } else {
          occupiedData.push(0);
          availableData.push(safeTotal);
        }

      });
    }
  } else {
    roomDetails.forEach(({occupied, totalrooms }) => {
      const safeTotal = Math.max(occupied, totalrooms);
      occupiedData.push(occupied);
      availableData.push(safeTotal - occupied);
    });
  }
  


  const series = [
    {
      name: "Occupied",
      data: occupiedData,
    },
    {
      name: "Available",
      data: availableData,
    },
  ];

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      stacked: true,
      stackType: "normal",
      toolbar: { show: false },
      redrawOnParentResize: true,
      foreColor: "#999",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 3,
        borderRadiusApplication: "end",
      },
    },
    colors: ["black", "#F3F2FC"],
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories,
      title: { text: "Month" },
      labels: { style: { fontSize: "14px" } },
    },
    yaxis: {
      title: { text: "Rooms" },
      labels: { show: true },
    },
    grid: {
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    legend: {
      show: true,
      position: "top",
    },
    fill: { opacity: 1 },
    tooltip: {
      enabled: true,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const label = w.globals.labels[dataPointIndex];
        const value = series[seriesIndex][dataPointIndex];
        const type = seriesIndex === 0 ? "Occupied" : "Available";
        return `<div class="arrow_box">
          <span><strong>${label}</strong><br/>${value} ${type} rooms</span>
        </div>`;
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={height ?? "100%"}
      width={width ?? "100%"}
      className={className}
    />
  );
};

export default RoomOccupancyChart;
